import cssVariables from 'tfs.css-variables'

export default {
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  input: {
    fontFamily: cssVariables.fontFamily,
    color: cssVariables.colorGrayC,
    fontSize: '1rem',
    lineHeight: 1,
    border: 'none',
    padding: '0.4rem',
    paddingRight: props => props.icon && '2rem',
    width: '100%',
    position: 'relative',
    zIndex: 1,
    backgroundColor: 'transparent',

    '&::placeholder': {
      color: cssVariables.colorGrayC,
    },

    '&:required': {
      boxShadow: 'none',
    },

    '&[type=date]': {
      paddingRight: '0.3rem',
    },

    '&::-webkit-calendar-picker-indicator, &::-webkit-inner-spin-button, &::-webkit-clear-button': {
      opacity: '0',
      WebkitAppearance: 'none',
    },
  },
  icon: {
    color: cssVariables.colorBlue,
    fontSize: '1.3rem',
    position: 'absolute',
    right: '0.3rem',
    zIndex: 0,
    cursor: 'text',
    backgroundColor: '#fff',
  },
  hasValue: {
    color: cssVariables.colorGrayB,
  },
  inputStyled: {
    border: `0.09rem solid ${cssVariables.colorWhiteBorder}`,
    borderRadius: '0.5rem',
    padding: '0 1rem 0 0.5rem',
    fontSize: '0.87rem',

    '&:focus': {
      borderColor: cssVariables.colorBlue,
      boxShadow: `0 0 0 0.05rem ${cssVariables.colorBlue}`,
      outline: 'none',
    },
  },
  isEditedInput: {
    borderColor: `${cssVariables.colorGreen}`,
    boxShadow: `0 0 0 0.05rem ${cssVariables.colorGreen}`,
  },
  requiredFieldBorder: {
    borderColor: `${cssVariables.colorErrorBackground}`,
    boxShadow: `0 0 0 0.05rem ${cssVariables.colorErrorBackground}`,
  },
  isInvalidInput: {
    color: cssVariables.colorError,
    '&::placeholder': {
      color: cssVariables.colorErrorBackground,
    },
  },
  isInvalidIcon: {
    color: cssVariables.colorErrorBackground,
  },
  disabled: {
    backgroundColor: `${cssVariables.colorGrayF}`,
  },
  label: {
    marginRight: '0.5rem',
  },
}
